import React from 'react';
import {
  TResponsiveTableRowRenderer,
  TResponsiveTableRowRendererProps,
} from '../types';

const DefaultRowRenderer: TResponsiveTableRowRenderer = React.forwardRef<
  HTMLTableRowElement,
  TResponsiveTableRowRendererProps
>(({ row, rowIndex, ...props }, currentRef) => (
  <tr ref={currentRef as React.RefObject<HTMLTableRowElement>} {...props} />
));
export default DefaultRowRenderer;
